import { FsForwardCupModeFormat } from "db/model/match/Set/CupMode/Forward/FsForwardCupModeFormat";
import { mapCupModeFormatBase } from "../FsCupModeFormat";
import { ForwardCupModeFormat } from "model/Match/Set/CupMode/Format/ForwardCupModeFormat";

export const mapForwardCupModeFormat = (
  fsModel: FsForwardCupModeFormat
): ForwardCupModeFormat | undefined => {
  // We don't currently support the logic for non finalist mode
  if (!fsModel.finalist) {
    return undefined;
  }

  const cupModeBase = mapCupModeFormatBase(fsModel);
  if (!cupModeBase || !fsModel.pointsLimit) {
    return undefined;
  }

  return {
    ...cupModeBase,
    finalist: fsModel.finalist,
    pointsLimit: fsModel.pointsLimit,
    requiredTeamWinners: fsModel.requiredTeamWinners,
  };
};
